/**
 * Ajustes → Privacidad: cuánto tiempo se guardan las reuniones y si se pueden
 * compartir por link (apagarlo desactiva al instante todos los links).
 */
import { RETENCION_OPCIONES } from '@eco/shared'
import { formatDate } from '../lib/format'
import { useAsync } from '../lib/hooks'
import { errorText, useApp, useToast } from './AppContext'

const etiqueta = (d: number) =>
  d % 365 === 0 ? `${d / 365} ${d === 365 ? 'año' : 'años'}` : `${d} días`

export function OrgPrivacySection() {
  const { api } = useApp()
  const toast = useToast()
  const cfg = useAsync(() => api.orgSettings(), [api])

  async function save(p: { retencionDias?: number | null; compartirHabilitado?: boolean }) {
    try {
      await api.patchOrgSettings(p)
      await cfg.reload()
      toast('Guardado')
    } catch (e) {
      toast(errorText(e), 'error')
    }
  }

  if (!cfg.data) return null
  return (
    <section className="card stack">
      <h2>Privacidad</h2>
      <label className="field">
        <span>Borrar las reuniones (transcripción y notas) después de</span>
        <select
          value={cfg.data.retencionDias ?? ''}
          onChange={(e) => {
            const nueva = e.target.value ? Number(e.target.value) : null
            const actual = cfg.data!.retencionDias
            // Acortar borra reuniones: se confirma (y se borran recién en 7 días)
            if (
              nueva !== null &&
              (actual === null || nueva < actual) &&
              !window.confirm(
                `Las reuniones de más de ${etiqueta(nueva)} se borrarán en 7 días (te avisamos por correo). ¿Continuar?`
              )
            )
              return
            void save({ retencionDias: nueva })
          }}
        >
          {RETENCION_OPCIONES.map((d) => (
            <option key={d} value={d}>
              {etiqueta(d)}
            </option>
          ))}
          <option value="">Nunca (las borro yo)</option>
        </select>
      </label>
      <p className="faint" style={{ fontSize: 12, marginTop: -6 }}>
        {cfg.data.retencionDesde
          ? `Por el cambio reciente, se empieza a borrar el ${formatDate(cfg.data.retencionDesde)}. `
          : ''}
        Te avisamos por correo antes de borrar. El audio se borra siempre al terminar de procesar.
      </p>
      <label className="check">
        <input
          type="checkbox"
          checked={cfg.data.compartirHabilitado}
          onChange={(e) => void save({ compartirHabilitado: e.target.checked })}
        />
        <span>
          Permitir compartir por link y enviar notas por correo (el correo lleva un link). Si lo
          apagas, todos los links que ya existen dejan de funcionar al instante.
        </span>
      </label>
    </section>
  )
}
